import { render, staticRenderFns } from "./vehicleStaff.vue?vue&type=template&id=57985f0e"
import script from "./vehicleStaff.vue?vue&type=script&lang=js"
export * from "./vehicleStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports